module.exports = __webpack_public_path__ + "static/img/newsCenter.ea7d7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter.png
// module id = sa+J
// module chunks = 1